export const Version = {
	version: '1.38.0.1',
};
